import styled from "styled-components";

export const Title= styled.h3`
    margin-bottom: 4px;
    font-style: normal;
    color: var(--color-primary, #0039c5);
    display: flex;
    align-items: center;
    font-feature-settings: 'liga' off;
`